export const ANDROID = 'Android',
  IOS = 'iOS',
  DESKTOP = 'Desktop';
